//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const TYPE_OPTS = {
    water: [
        {
            text: '不限',
            value: ''
        },
        {
            text: '80万以下',
            value: '0-800000'
        },
        {
            text: '80-150万',
            value: '800000-1500000'
        },
        {
            text: '150-250万',
            value: '1500000-2500000'
        },
        {
            text: '250-350万',
            value: '2500000-3500000'
        },
        {
            text: '350-500万',
            value: '3500000-5000000'
        },
        {
            text: '500万以上',
            value: '5000000-99999999999999999'
        }
    ],
    square: [
        {
            text: '不限',
            value: ''
        },
        {
            text: '7000元/㎡以下',
            value: '0-7000'
        },
        {
            text: '7000元-12000元/㎡',
            value: '7000-12000'
        },
        {
            text: '12000元-18000元/㎡',
            value: '12000-180000'
        },
        {
            text: '18000元-25000元/㎡',
            value: '18000-25000'
        },
        {
            text: '25000元/㎡以上',
            value: '25000-99999999999'
        }
    ]
}

const getInit = () => {
    return {
        selected: '',
        selected_tx: '不限',
        tabs: [
            {
                text: '总价',
                value: 'water'
            },
            {
                text: '单价',
                value: 'square'
            }
        ],
        type: 'water',
        start: '',
        end: '',
        start_focus: false,
        end_focus: false
    }
}

export default {
    data () {
        return getInit()
    },
    destroyed () {
        this.type = 'water'
        this.start = ''
        this.end = ''
        this.selected = ''
    },
    computed: {
        start_text () {
            return this.start || this.input_tip_start
        },
        end_text () {
            return this.end || this.input_tip_end
        },
        opts () {
            return TYPE_OPTS[this.type]
        },
        input_tip_start () {
            return this.type === 'water' ? '最低总价' : '最低单价'
        },
        input_tip_end () {
            return this.type === 'water' ? '最高总价' : '最高单价'
        }
    },
    methods: {
        clearInput () {
            this.start = ''
            this.end = ''
        },
        changeType (e) {
            this.type = e.currentTarget.dataset.type
            this.clearInput()
        },
        onSelect (e) {
            this.selected = e.currentTarget.dataset.value
            this.selected_tx = e.currentTarget.dataset.text
            this.clearInput()
        },
        changeStartFocus (focus) {
            this.selected = ''
            this.selected_tx = ''
            this.start_focus = !this.start_focus
        },
        changeEndFocus (focus) {
            this.end_focus = !this.end_focus
        },
        changeStart (e) {
            this.start = e.target.value
        },
        changeEnd (e) {
            this.end = e.target.value
        },
        confirm () {
            let { start, end, selected_tx } = this
            if (this.start && this.end) {
                if (this.type === 'water') {
                    selected_tx = `${start}万-${end}万`
                    start *= 10000
                    end *= 10000
                } else {
                    selected_tx = `${start}元-${end}元/㎡`
                }
                this.selected_tx = selected_tx
            }
            const price = start != '' && end !='' ? `${start}-${end}` : this.selected
            if (!price && (start || end)) {
                this.$wx.showToast({
                    title: '请选择或填写价格',
                    icon: 'none'
                })
                return
            }
            if (start && end && start > end) {
                this.$wx.showToast({
                    title: '起始价格不能高于最高价格',
                    icon: 'none'
                })
                return
            }
            this.$emit('change', this.type, price, selected_tx)
        }
    }
}
